import { useCallback, useContext, useMemo } from "react";
import { GameContext } from "../contexts";
import { PlayerAction } from "../types";

type UseGameFormProps = {
  gameSubmit?: () => PlayerAction;
  customSubmit?: () => void;
  playerState?: { name?: string; meta?: { sprite_id?: number } };
};

export const useGameForm = ({
  gameSubmit,
  customSubmit,
  playerState,
}: UseGameFormProps) => {
  const { submit } = useContext(GameContext);

  const handleSubmit = useCallback(() => {
    if (customSubmit) {
      customSubmit();
    } else if (gameSubmit) {
      submit(gameSubmit());
    }
  }, [customSubmit, gameSubmit, submit]);

  const avatarHeaderProps = useMemo(
    () => ({
      avatarName: playerState?.name,
      avatarSpriteId: playerState?.meta?.sprite_id,
    }),
    [playerState?.name, playerState?.meta?.sprite_id]
  );

  return {
    handleSubmit,
    avatarHeaderProps,
  };
};
